import React from 'react';
import { getUserInitials, getUserInitialsColor } from '../../utils/userInitials';
import './UserAvatar.css';

/**
 * UserAvatar component that displays user initials instead of profile images
 * @param {Object} props
 * @param {string} props.firstName - User's first name
 * @param {string} props.lastName - User's last name
 * @param {number} props.size - Avatar size in pixels (default: 40)
 * @param {string} props.className - Additional CSS classes
 * @param {Object} props.style - Additional inline styles
 * @param {string} props.fallback - Fallback character (default: 'U')
 */
const UserAvatar = ({ 
  firstName, 
  lastName, 
  size = 40, 
  className = '', 
  style = {}, 
  fallback = 'U' 
}) => {
  const initials = getUserInitials(firstName, lastName, fallback);
  const backgroundColor = getUserInitialsColor(firstName, lastName);
  
  const avatarStyle = {
    width: `${size}px`,
    height: `${size}px`,
    backgroundColor,
    fontSize: `${size * 0.4}px`, // Font size is 40% of avatar size
    ...style
  };

  return (
    <div 
      className={`user-avatar-initials ${className}`}
      style={avatarStyle}
      title={`${firstName || ''} ${lastName || ''}`.trim() || 'User'}
    >
      {initials}
    </div>
  );
};

export default UserAvatar;